import { TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { getBenef } from '../../../../../Store/storages/BeneficiarioStorage';
import { sxMessageTextField, sxSubTitle } from '../../../../../assets/styles/CommonSxProps';
import DefaultButton from '../../../../../components/Accessibility/DefaultButton';
import PageTitle from '../../../../../components/Accessibility/PageTitle';
import VoltarButton from '../../../../../components/Accessibility/VoltarButton';
import WhiteContainer from '../../../../../components/Accessibility/WhiteContainer';
import LoadingApp from '../../../../../components/LoadingApp';
import ModalFeedBack from '../../../../../components/ModalFeedBack';
import { enviarMensagemPersonal, getConversasPersonal } from '../../../../../services/PlanoMaisService';
import { sxDarkGreyBody } from '../../../../MeuPlano/PermissoesVisualizacao/sxProps';
import './styles.css';

const NovaConversaPersonal: React.FC = () => {

  const accessibility = useAccessibility();
  const navigate = useNavigate();
  const [mensagem, setMensagem] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning' | 'none', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);
  const benef = getBenef();

  const handleNewConversation = async () => {
    setLoading(true);
    const response = await enviarMensagemPersonal({ mensagem: mensagem, idDestinatario: benef?.idMedicoReferencia });
    const mensagens = (await getConversasPersonal())?.data
    if (response?.status === 200 && mensagens?.length) {
        const id = mensagens[0].idMensagem
        navigate(`/saudeOnline/faleComPersonal/conversaEquipe/conversas/${id}/chat`);
    } else {
      console.error(response);
      const mensagem = response?.data.mensagem ? response.data.mensagem : 'Ocorreu um erro ao enviar sua mensagem. Tente novamente mais tarde.';
      openModalFeedback('Erro', mensagem, 'Fechar', closeModalFeedback, closeModalFeedback, 'error');
    }
    setLoading(false);
  }

  const closeModalFeedback = () => {
    setModalFeedback(null);
  }

  const openModalFeedback = (
    title: string, subTitle: string, textButton: string, closeAction: () => void,
    buttonAction: () => void, icon?: 'success' | 'warning' | 'error' | 'none', showButtonModal?: boolean
  ) => {
    setModalFeedback({
      icon,
      title,
      subTitle,
      textButton,
      showButtonModal: showButtonModal || false,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  return (
    <>
      <LoadingApp showLoading={loading} text={'Criando mensagem...'} />
      <div className='chat-infos-container'>
        <PageTitle text='Nova conversa' />

        <WhiteContainer className='advice-container' style={{ marginBottom: '0px' }}>
          <Typography
            sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility}
          >
            Este atendimento tem como objetivo orientar sobre dúvidas, procedimentos, solicitação de guias, agendamentos e consultas, e não substitui um atendimento médico. O contato será respondido em breve, conforme horário de atendimento do Espaço Personal. Caso necessário, você pode entrar em contato pelo WhatsApp da recepção do Espaço Personal via (19) 99652-2208.
            <br /><br />
            Durante a conversa, você pode anexar arquivos. São aceitos arquivos com até 4 MB, nos formatos .png, .jpg, .gif ou .pdf.
          </Typography>
        </WhiteContainer>

        <Typography sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility}>
          Destinatário: {benef?.nomeMedicoReferencia || ''}
        </Typography>

        <div className='textfield-input-area'>
          <Typography sx={sxSubTitle}>Mensagem</Typography>
          <TextField
            id="outlined-textarea"
            type='text'
            value={mensagem}
            onChange={(e) => { setMensagem(e.target.value); }}
            placeholder='Conte um pouco mais sobre o motivo de seu contato'
            multiline
            inputProps={{ maxLength: 500 }}
            sx={sxMessageTextField}
          />
        </div>
        <DefaultButton aria-label={`Iniciar nova conversa com ${benef?.nomeMedicoReferencia || ''}`} text='Iniciar nova conversa' onClick={handleNewConversation} disabled={mensagem.trim() === ''} />
        <VoltarButton text='Voltar' aria-label="voltar para fale com personal" onClick={() => window.history.back()} />
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
        classNameModal='modal-instrucao'
      />
    </>
  )
}

export default NovaConversaPersonal;